import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Loading from "./page/loading";
import Download from "./page/download";
import Login from "./page/login";
import Template from "./page/template";

import Dashboard from "./page/admin/dashboard";
import Admin from "./page/admin/user/admin";
import Farmer from "./page/admin/user/farmer";

import ActivityTypeLand from "./page/admin/setting/activity_type_land.js";
import ActivityTypeCane from "./page/admin/setting/activity_type_cane.js";
import CaneCutter from "./page/admin/setting/cane_cutter.js";
import CaneType from "./page/admin/setting/cane_type.js";
import CaneVarieties from "./page/admin/setting/cane_varieties.js";
import CuttingType from "./page/admin/setting/cutting_type.js";
import DocumentRights from "./page/admin/setting/document_rights.js";
import FertilizerFormula from "./page/admin/setting/fertilizer_formula.js";
import FertilizerBrand from "./page/admin/setting/fertilizer_brand.js";
import LiquidFertilizerType from "./page/admin/setting/liquid_fertilizer_type.js";
import OwnershipStatus from "./page/admin/setting/ownership_status.js";
import PlotPreparationStatus from "./page/admin/setting/plot_preparation_status.js";
import PlotStatus from "./page/admin/setting/plot_status.js";
import ProductionYear from "./page/admin/setting/production_year.js";
import SoilType from "./page/admin/setting/soil_type.js";
import SprayingType from "./page/admin/setting/spraying_type.js";
import TruckDriver from "./page/admin/setting/truck_driver.js";
import Truck from "./page/admin/setting/truck.js";

import Report from "./page/admin/report/report";
import Map from "./page/admin/report/map";

import TemplateDocument from "./document/template";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Loading />} />
    <Route path="/download" element={<Download />} />
    <Route path="/login" element={<Login />} />
    <Route path="/template" element={<Template />} />

    <Route path="/dashboard" element={<Dashboard />} />

    <Route path="/admin" element={<Admin />} />
    <Route path="/farmer" element={<Farmer />} />

    <Route path="/setting/activity_type_land" element={<ActivityTypeLand />} />
    <Route path="/setting/activity_type_cane" element={<ActivityTypeCane />} />
    <Route path="/setting/cane_cutter" element={<CaneCutter />} />
    <Route path="/setting/cane_type" element={<CaneType />} />
    <Route path="/setting/cane_varieties" element={<CaneVarieties />} />
    <Route path="/setting/cutting_type" element={<CuttingType />} />
    <Route path="/setting/document_rights" element={<DocumentRights />} />
    <Route path="/setting/fertilizer_formula" element={<FertilizerFormula />} />
    <Route path="/setting/fertilizer_brand" element={<FertilizerBrand />} />
    <Route path="/setting/liquid_fertilizer_type" element={<LiquidFertilizerType />} />
    <Route path="/setting/ownership_status" element={<OwnershipStatus />} />
    <Route path="/setting/plot_preparation_status" element={<PlotPreparationStatus />} />
    <Route path="/setting/plot_status" element={<PlotStatus />} />
    <Route path="/setting/production_year" element={<ProductionYear />} />
    <Route path="/setting/soil_type" element={<SoilType />} />
    <Route path="/setting/spraying_type" element={<SprayingType />} />
    <Route path="/setting/truck_driver" element={<TruckDriver />} />
    <Route path="/setting/truck" element={<Truck />} />

    <Route path="/report" element={<Report />} />
    <Route path="/map" element={<Map />} />

    <Route path="/document/template" element={<TemplateDocument />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
